import React from 'react';

function CompetitionEmailPanel({ allEmailPlayersSelected, compEmailMode, compGeneralSendMode, compGeneralTemplateId, compQuickEmailBody, compQuickEmailSubject, competitionPlayersWithEmail, emailSelectablePlayers, hasEntryConfirmationTemplate, isAdmin, manualCompEmailTemplates, openProfile, selectedComp, selectedCompPlayerIds, sendCompetitionEmail, sendingCompEmail, setCompEmailMode, setCompGeneralSendMode, setCompGeneralTemplateId, setCompQuickEmailBody, setCompQuickEmailSubject, setSelectedCompPlayerIds, users }) {
  if (!(isAdmin && emailSelectablePlayers.length > 0 && selectedComp.format !== 'singles')) return null;
  return (
      <div style={{ marginTop: '16px' }}>
        {competitionPlayersWithEmail.length > 0 && (
          <div className="w3-panel w3-pale-blue w3-round" style={{ padding: '8px 12px', marginBottom: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <strong className="w3-small"><i className="fa fa-users w3-margin-right"></i>Registered Players</strong>
              <button
                className="w3-button w3-tiny w3-theme-l4 w3-round"
                onClick={() => {
                  if (allEmailPlayersSelected) setSelectedCompPlayerIds([]);
                  else setSelectedCompPlayerIds(competitionPlayersWithEmail.map(p => p.id));
                }}>
                {allEmailPlayersSelected ? 'Clear Email Picks' : `Select All (${competitionPlayersWithEmail.length})`}
              </button>
            </div>
            <div className="w3-small w3-text-grey" style={{ marginTop: '4px' }}>
              Tick players below to choose who receives an email.
            </div>
          </div>
        )}

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
          {emailSelectablePlayers.map(p => (
            <span
              key={`team-email-${p.id}`}
              className={`w3-tag w3-round ${p.hasPaid ? 'w3-theme-l2' : 'w3-theme-l2'} email-recipient-chip ${selectedCompPlayerIds.includes(p.id) ? 'email-recipient-chip-selected' : ''} ${!p.email ? 'email-recipient-chip-disabled' : ''}`}
              style={{ fontSize: 'var(--gs-text-sm)', padding: '6px 12px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
              <input
                type="checkbox"
                className="email-recipient-checkbox"
                checked={selectedCompPlayerIds.includes(p.id)}
                disabled={!p.email}
                onChange={(e) => {
                  e.stopPropagation();
                  setSelectedCompPlayerIds(prev => {
                    if (prev.includes(p.id)) return prev.filter(id => id !== p.id);
                    if (!p.email) return prev;
                    return [...prev, p.id];
                  });
                }}
                title={p.email ? 'Select for email' : 'No email address'}
              />
              <span onClick={() => openProfile(p.id)}>
                <i className="fa fa-user w3-margin-right"></i>{p.name}
              </span>
              {!p.email && <span className="w3-tag w3-round w3-amber w3-tiny">No Email</span>}
            </span>
          ))}
        </div>

        {competitionPlayersWithEmail.length > 0 && (
          <p className="w3-small w3-text-grey" style={{ marginTop: '6px', marginBottom: 0 }}>
            Email recipients selected: {selectedCompPlayerIds.length} of {competitionPlayersWithEmail.length} with email addresses.
          </p>
        )}

        {selectedCompPlayerIds.length > 0 && (
          <div className="w3-panel w3-pale-green w3-round" style={{ marginTop: '10px', padding: '10px 12px' }}>
            <strong className="w3-small"><i className="fa fa-paper-plane w3-margin-right"></i>Email Selected Players</strong>
            <div style={{ display: 'flex', gap: '16px', marginTop: '8px', flexWrap: 'wrap' }}>
              <label className="w3-small" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                <input
                  type="radio"
                  className="w3-radio"
                  name="teamCompEmailMode"
                  checked={compEmailMode === 'general'}
                  onChange={() => setCompEmailMode('general')}
                />
                General Email
              </label>
              <label className="w3-small" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                <input
                  type="radio"
                  className="w3-radio"
                  name="teamCompEmailMode"
                  checked={compEmailMode === 'entry-confirmation'}
                  onChange={() => setCompEmailMode('entry-confirmation')}
                />
                Competition Entry Confirmation
              </label>
            </div>

            {compEmailMode === 'general' ? (
              <div style={{ marginTop: '8px' }}>
                <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '8px' }}>
                  <label className="w3-small" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                    <input
                      type="radio"
                      className="w3-radio"
                      name="teamCompGeneralSendMode"
                      checked={compGeneralSendMode === 'template'}
                      onChange={() => setCompGeneralSendMode('template')}
                    />
                    Use Saved Template
                  </label>
                  <label className="w3-small" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                    <input
                      type="radio"
                      className="w3-radio"
                      name="teamCompGeneralSendMode"
                      checked={compGeneralSendMode === 'quick'}
                      onChange={() => setCompGeneralSendMode('quick')}
                    />
                    Quick Email
                  </label>
                </div>

                {compGeneralSendMode === 'template' ? (
                  <>
                    <select
                      className="w3-select w3-border w3-round"
                      value={compGeneralTemplateId}
                      onChange={e => setCompGeneralTemplateId(e.target.value)}>
                      <option value="">Select general template...</option>
                      {manualCompEmailTemplates.map(t => (
                        <option key={t.id} value={t.id}>{t.name}</option>
                      ))}
                    </select>
                    {manualCompEmailTemplates.length === 0 && (
                      <p className="w3-small w3-text-grey" style={{ marginTop: '6px', marginBottom: 0 }}>
                        No general templates available yet. Create one in the Email Templates tab.
                      </p>
                    )}
                  </>
                ) : (
                  <>
                    <input
                      className="w3-input w3-border w3-round"
                      placeholder="Quick email subject"
                      value={compQuickEmailSubject}
                      onChange={e => setCompQuickEmailSubject(e.target.value)}
                      style={{ marginBottom: '8px' }}
                    />
                    <textarea
                      className="w3-input w3-border w3-round"
                      placeholder="Write your quick email message here..."
                      value={compQuickEmailBody}
                      onChange={e => setCompQuickEmailBody(e.target.value)}
                      style={{ minHeight: '110px', resize: 'vertical' }}
                    />
                    <p className="w3-small w3-text-grey" style={{ marginTop: '6px', marginBottom: 0 }}>
                      Placeholders supported: {'{{userName}}'}, {'{{clubName}}'}, {'{{competitionName}}'}, {'{{competitionEntryFee}}'}, {'{{competitionEntryFeeDisplay}}'}
                    </p>
                  </>
                )}
              </div>
            ) : (
              <div className="w3-small" style={{ marginTop: '8px' }}>
                {hasEntryConfirmationTemplate ? (
                  <span className="w3-text-grey">Uses your club's registration confirmation template.</span>
                ) : (
                  <span className="w3-text-red">Competition entry confirmation template not found.</span>
                )}
              </div>
            )}

            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <span className="w3-small w3-text-grey">
                Sending to {selectedCompPlayerIds.length} selected player{selectedCompPlayerIds.length !== 1 ? 's' : ''}
              </span>
              <button
                className="w3-button w3-theme w3-round"
                disabled={
                  sendingCompEmail ||
                  selectedCompPlayerIds.length === 0 ||
                  (compEmailMode === 'general' && compGeneralSendMode === 'template' && !compGeneralTemplateId) ||
                  (compEmailMode === 'general' && compGeneralSendMode === 'quick' && (!compQuickEmailSubject.trim() || !compQuickEmailBody.trim())) ||
                  (compEmailMode === 'entry-confirmation' && !hasEntryConfirmationTemplate)
                }
                onClick={sendCompetitionEmail}>
                <i className="fa fa-send w3-margin-right"></i>
                {sendingCompEmail ? 'Sending...' : 'Send Email'}
              </button>
            </div>
          </div>
        )}
      </div>
  );
}

export default CompetitionEmailPanel;
